import { useEffect, useRef } from "react";

// Lägger klassen "paus" på elementet när det är utanför skärmen, så att CSS-animationer står still
// (sparar batteri). Alla animationer pausas samtidigt och håller därför takten.
export function usePausUtanfor<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(([e]) => el.classList.toggle("paus", !e.isIntersecting));
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}

// Lägger klassen "syns" första gången elementet kommer in i bild. CSS sköter själva övergången;
// utan IntersectionObserver eller med reducerad rörelse syns sluttillståndet direkt.
export function useSyns<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { el.classList.add("syns"); return; }
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("syns"); io.disconnect(); }
    }, { threshold: 0.35 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}
